module.exports = __webpack_public_path__ + "media/icons/logo-mark-91fb6f6a.svg";